/* tslint:disable */
/* eslint-disable */
/**
 * Email API
 * API for managing email templates and sending documents via Brevo
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Commande pour prévisualiser un template email de document. Récupère automatiquement les paramètres (nom client, logo, couleurs) à partir du RisqueAssureId
 * @export
 * @interface GetDocumentTemplatePreviewCommand
 */
export interface GetDocumentTemplatePreviewCommand {
    /**
     * ID du risque assuré (pour récupérer le courtier, la plateforme, le thème et l'assuré principal)
     * @type {string}
     * @memberof GetDocumentTemplatePreviewCommand
     */
    risqueAssureId: string;
    /**
     * Type de document (ex - Contrat, Devis, Attestation)
     * @type {number}
     * @memberof GetDocumentTemplatePreviewCommand
     */
    fileTypeInt: number;
    /**
     * Texte personnalisé du courtier (optionnel)
     * @type {string}
     * @memberof GetDocumentTemplatePreviewCommand
     */
    customText?: string | null;
    /**
     * ID du template Brevo (optionnel, défaut = 16)
     * @type {number}
     * @memberof GetDocumentTemplatePreviewCommand
     */
    templateId?: number | null;
}

/**
 * Check if a given object implements the GetDocumentTemplatePreviewCommand interface.
 */
export function instanceOfGetDocumentTemplatePreviewCommand(value: object): value is GetDocumentTemplatePreviewCommand {
    if (!('risqueAssureId' in value) || value['risqueAssureId'] === undefined) return false;
    if (!('fileTypeInt' in value) || value['fileTypeInt'] === undefined) return false;
    return true;
}

export function GetDocumentTemplatePreviewCommandFromJSON(json: any): GetDocumentTemplatePreviewCommand {
    return GetDocumentTemplatePreviewCommandFromJSONTyped(json, false);
}

export function GetDocumentTemplatePreviewCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDocumentTemplatePreviewCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'risqueAssureId': json['risqueAssureId'],
        'fileTypeInt': json['fileTypeInt'],
        'customText': json['customText'] == null ? undefined : json['customText'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
    };
}

export function GetDocumentTemplatePreviewCommandToJSON(json: any): GetDocumentTemplatePreviewCommand {
    return GetDocumentTemplatePreviewCommandToJSONTyped(json, false);
}

export function GetDocumentTemplatePreviewCommandToJSONTyped(value?: GetDocumentTemplatePreviewCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'risqueAssureId': value['risqueAssureId'],
        'fileTypeInt': value['fileTypeInt'],
        'customText': value['customText'],
        'templateId': value['templateId'],
    };
}

